import React from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import {
  AppBar,
  Box,
  Container,
  Paper,
  Tab,
  Tabs,
} from "@material-ui/core"

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `tab-navigation-${index}`,
    "aria-controls": `tabpanel-${index}`,
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  header: {
    margin: "0 auto",
    maxWidth: 1280,
    paddingTop: theme.spacing(5),
    paddingLeft: 40,
    paddingRight: 40,
    width: "100%",
  },
  content: {
    margin: "0 auto",
    maxWidth: 1280,
    paddingLeft: 40,
    paddingRight: 40,
    paddingTop: 40,
    width: "100%",
  },
}))

export default function SimpleTabs({ items, header }) {
  const classes = useStyles()
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <div>
      <Paper className={classes.root} elevation={4}>
        <Container className={`${classes.header}`}>
          {header}
          <AppBar elevation={0} position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="tabs navigation"
              TabIndicatorProps={{
                style: {
                  backgroundColor: "white",
                  height: 4,
                },
              }}
            >
              {items.map((item, index) => (
                <Tab key={index} label={item.title} {...a11yProps(index)} />
              ))}
            </Tabs>
          </AppBar>
        </Container>
      </Paper>
      <Container className={classes.content}>
        {items.map((item, index) => (
          <TabPanel key={index} value={value} index={index}>
            {item.content}
          </TabPanel>
        ))}
      </Container>
    </div>
  )
}
